import React from 'react';
import ImprovementPDF from './ImprovementPDF';

const Improvement = () => <ImprovementPDF />;

export default Improvement;